.financier {
  display: flex;
  flex-direction: column;
  padding: 2rem 3rem;
  justify-content: center;
  background-color: var(--deposit-withdraw-bg-color);
  border-radius: 1rem;
  margin: 3rem 2.5rem;
}

.divider {
  height: 1px;
  border-top: 1px solid #d1d1d1;
  margin: 1.5rem 0;
}

.header {
  display: flex;
  flex-direction: column;
}

.referralCode {
  display: flex;
  flex-direction: column;
  margin-top: 1rem;
}

.referralCodeInner {
  display: flex;
  gap: 0.5rem;
}

.faq {
  display: flex;
  align-items: flex-end;
  gap: 2rem;
}

.extraLinksMobileView {
  /* display: none; */
  display: flex;
  flex-direction: column;
  gap: 1rem;
  margin-top: 1.5rem;
}

.logoutBtn {
  margin-top: 1rem;
  border: 1px solid var(--red-text-color);
  border-radius: 0.3rem;
  width: 30%;
}

@media only screen and (max-width: 550px) {
  .financier {
    padding: 1.5rem 1.5rem;
  }

  .divider {
    margin: 1rem 0;
  }

  .extraLinksMobileView {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 1.5rem;
  }
}
